
import UITrendingStockWidget from '~/components/ui/widgets/symbol/UITrendingStockWidget.vue';
import { mapActions, mapGetters } from 'vuex';
import { TrendingTickerType } from '~/utils/constants/trendingTickerTypes';

export default {
  Name: 'TrendingLosersTickersWidgetWrapper',
  components: { UITrendingStockWidget },
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  async fetch() {
    if (process.client) {
      if (!this.trendingLosersTickersRes.data) {
        await this.getTrendingTickers({
          limit: this.limit,
          trendingType: TrendingTickerType.LOSERS,
          type: 1,
        });
      }
    }
  },
  computed: {
    ...mapGetters('trendingTickersWidget', ['trendingLosersTickersRes']),
    tickersList() {
      return this.trendingLosersTickersRes.data;
    },
  },
  methods: {
    ...mapActions('trendingTickersWidget', ['getTrendingTickers']),
  },
};
